import React, { FC } from "react"
import { MediaApi } from "../../../../api/MediaApi"

interface SignaturePreviewProps {
    id?: string
}

export const FieldSignaturePreview: FC<SignaturePreviewProps> = ({ id }) => {
    const pictureUrl = id ? MediaApi.download(id) : undefined;
    return (
        <>
        { pictureUrl && (
            <div 
                className="signature-container saved-signature"
                style={{ backgroundImage: `url(${pictureUrl})` }}>
            </div>) }
        </>
    )
}